import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import Constants from '../../utils/Constants';
import useAuthentication from '../../hooks/useAuthentication';
import { hasUserRole } from '../../utils/AuthUtils';

import Menu from './Menu';

import WelcomePage from '../view/welcome';
import Login from '../view/login';
import Logout from '../view/logout';
import LandingPage from '../view/landing/LandingPage';

import InventoryList from '../view/inventory/InventoryList';
import InventoryCreate from '../view/inventory/InventoryCreate';
import InventoryEdit from '../view/inventory/InventoryEdit';

import InventoryPdf from '../view/pdfGenerate/InventoryPdf'; 
import LockerContentView from '../view/complete/LockerContentView';
import CompleteInventoryWorkflow from '../view/complete/CompleteInventoryWorkflow';
import ManageCompletion from '../view/inventory/manage/ManageCompletion';

import GalleryWorkflow from '../view/inventory/gallery/GalleryWorkflow';

import HoseListing from '../view/hoseManagement/HoseListing';
import EditHose from '../view/hoseManagement/EditHose';
import TestHose from '../view/hoseManagement/TestHose';
import HoseHistory from '../view/hoseManagement/HoseHistory';


const Layout = function(props) {
  const [isAuthenticated] = useAuthentication();

  const inventoryUserRoles = [Constants.UserRole.InventoryUser, Constants.UserRole.InventoryManager];
  const hoseUserRoles = [Constants.UserRole.HoseUser, Constants.UserRole.HoseManager];

  const RequireAuth = function({ children }) {
    return isAuthenticated ? children : <Navigate to={Constants.RoutePath.Login} />;
  }

  const RedirectToLandingIfAuthDetected = function({children}) {
    return isAuthenticated ? <Navigate to={Constants.RoutePath.LandingPage} /> : children;
  }

  const RequireAuthRole = function({roles, children}) {
    if (!isAuthenticated || !hasUserRole(roles)) {
      return <Navigate to={Constants.RoutePath.LandingPage} /> 
    }

    return children;
  }

  return (
    <div id="layout">
      <Menu />        
      
      <Routes>
        <Route path={Constants.RoutePath.Home} exact element={
          <RedirectToLandingIfAuthDetected> 
            <WelcomePage />
          </RedirectToLandingIfAuthDetected>
        }/>

        <Route path={Constants.RoutePath.Login} exact element={
          <RedirectToLandingIfAuthDetected> 
            <Login />
          </RedirectToLandingIfAuthDetected> 
        }/>

        <Route path={Constants.RoutePath.Logout} exact element={
          <Logout /> 
        }/>


        /* Secure Routes Below */ 

        <Route path={Constants.RoutePath.Landing} exact element={
          <RequireAuth>
            <LandingPage />
          </RequireAuth>
        }/>

        
        /* Inventory Routes */

        <Route path={Constants.RoutePath.Inventory.List} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <InventoryList />
          </RequireAuthRole>
        }/>
        <Route path={Constants.RoutePath.Inventory.Create} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <InventoryCreate />
          </RequireAuthRole>
        }/>
        <Route path={Constants.RoutePath.Inventory.Edit(':inventoryId')} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <InventoryEdit />
          </RequireAuthRole>
        }/>
        <Route path={Constants.RoutePath.Inventory.Pdf(':inventoryId')} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <InventoryPdf />
          </RequireAuthRole>
        }/>
        <Route path={Constants.RoutePath.Inventory.Complete(':inventoryId')} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <CompleteInventoryWorkflow />
          </RequireAuthRole>
        }/>
        <Route path={Constants.RoutePath.Inventory.CompleteLocker(':lockerId')} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <LockerContentView />
          </RequireAuthRole>
        }/>

        <Route path={Constants.RoutePath.Gallery.View} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <GalleryWorkflow /> 
          </RequireAuthRole>
        }/>

        <Route path={Constants.RoutePath.Inventory.Manage} exact element={
          <RequireAuthRole roles={inventoryUserRoles}>
            <ManageCompletion />
          </RequireAuthRole>
        }/>

        
        /* Hose Management Routes */

        <Route path={Constants.RoutePath.HoseManagement.Listing} exact element={
          <RequireAuthRole roles={hoseUserRoles}>
            <HoseListing />
          </RequireAuthRole>
        }/>

        <Route path={Constants.RoutePath.HoseManagement.Test(':hoseId')} exact element={
          <RequireAuthRole roles={hoseUserRoles}>
            <TestHose />
          </RequireAuthRole>
        }/>
        
        <Route path={Constants.RoutePath.HoseManagement.Edit(':hoseId')} exact element={
          <RequireAuthRole roles={Constants.UserRole.HoseManager}>
            <EditHose />
          </RequireAuthRole>
        }/>

        <Route path={Constants.RoutePath.HoseManagement.History(':hoseId')} exact element={
          <RequireAuthRole roles={hoseUserRoles}>
            <HoseHistory />
          </RequireAuthRole>
        }/>

      </Routes>
    </div>
  );
};

export default Layout;

